<template>
    <div class="card-bg p-4 rounded-lg h-full">
        <div class="flex items-center justify-between mb-2">
            <span class="font-medium">Current Balance</span>
            <i class="pi pi-info-circle text-gray-400 cursor-help"
                v-tooltip.bottom="'User\'s available balance for withdrawal'" />
        </div>
        <div class="flex items-center justify-between">
            <div>
                <template v-if="loading">
                    <Skeleton width="150px" height="2rem" class="mb-2" />
                </template>
                <div v-else class="text-2xl font-bold text-center">
                    {{ formatCurrency(walletBalance) }}
                </div>
                <Button 
                label="Transaction History" 
                icon="pi pi-history" 
                severity="info" 
                @click="toggleTransactions"
                class="p-button-sm p-button-outlined mt-1" 
            />
            </div>
        </div>
    </div>

    <Transactions v-if="!loading"
        v-model:visible="isTransactionsVisible" 
        :walletId="walletId" 
        :currentBalance="walletBalance"
        @wallet-updated="handleWalletUpdate"
    />
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Skeleton from 'primevue/skeleton';
import Button from 'primevue/button';
import { formatCurrency } from '@/utils/currencies';
import WalletService from '@/services/WalletService';
import Transactions from '@/components/finance/Transactions.vue';

const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    userId: {
        type: String,
        required: true
    }
});

const walletBalance = ref(null);
const walletId = ref(null);
const walletLoading = ref(true);

const isTransactionsVisible = ref(false);
const toggleTransactions = () => {
    isTransactionsVisible.value = !isTransactionsVisible.value;
};

const fetchUserWallet = async () => {
    try {
        const response = await WalletService.getUserWallet(props.userId);
        walletId.value = response.data.walletId;    
        walletBalance.value = response.data.balance;
    } catch (error) {
        console.error(error);
    } finally {
        walletLoading.value = false;
    }
};

const handleWalletUpdate = async () => {
    // Refresh wallet balance or other necessary updates
    await fetchUserWallet();
    toggleTransactions();
    // Add your refresh logic here
};

onMounted(() => {
    fetchUserWallet();
});
</script>